module.exports = __webpack_public_path__ + "d55b6e9754329ca3ceaa5af25ee8f82f.svg";